import { gameState, config } from '@js/state';
import {
  enablePointerEvents,
  disablePointerEvents,
} from '@utils/pointer-events-control';

export default class EndScene extends Phaser.Scene {
  constructor() {
    super({ key: 'EndScene' });
  }

  preload() {}

  create() {
    enablePointerEvents();

    gameState.qnum = gameState.questionNumber;
    gameState.retry = true;
    if (gameState.correct >= 6) {
      gameState.gameWin = true;
    } else {
      gameState.gameWin = false;
    }

    this.kawase = this.plugins.get('rexkawaseblurpipelineplugin');
    if (this.kawase && gameState.cam) {
      this.kawase.add(gameState.cam, config);
    }

    this.add.sprite(0, 0, 'sbg').setOrigin(0).setTint(0x000).setAlpha(0.6);

    this.confettiaudio = this.sound.add('confettiaudio').setVolume(0.2);
    this.rewardReveal = this.sound.add('reward_reveal').setVolume(0.2);

    this.endanim = false;
    this.cameras.main.fadeIn(500, 255, 255, 255);

    this.anims.create({
      key: 'showglitter',
      frames: this.anims.generateFrameNames('glitter', {
        start: 0, end: 32, zeroPad: 0, prefix: 'glitterAnim', suffix: '.png',
      }),
      frameRate: 15, repeat: -1,
    });

    this.anims.create({
      key: 'circleopen',
      frames: this.anims.generateFrameNames('baseCircle', {
        start: 0, end: 74, zeroPad: 0, prefix: 'baseCircleAnim', suffix: '.png',
      }),
      frameRate: 30, repeat: 0,
    });

    this.anims.create({
      key: 'rewardopen',
      frames: this.anims.generateFrameNames('rewardLight', {
        start: 0, end: 155, zeroPad: 0, prefix: 'rewardLightAnim', suffix: '.png',
      }),
      frameRate: 30, repeat: 0,
    });

    this.anims.create({
      key: 'circleglitterloop',
      frames: this.anims.generateFrameNames('baseCircle', {
        start: 74, end: 155, zeroPad: 0, prefix: 'baseCircleAnim', suffix: '.png',
      }),
      frameRate: 30, repeat: -1,
    });

    this.spotlight = this.add.sprite(config.width / 2, config.height / 2, 'spotlight');
    this.anims.create({
      key: 'spotlightOpen',
      frames: this.anims.generateFrameNames('spotlight', {
        start: 0, end: 188, zeroPad: 0, prefix: 'spotlight0', suffix: '.png',
      }),
      frameRate: 20, repeat: 0,
    });
    this.anims.create({
      key: 'spotlightClose',
      frames: this.anims.generateFrameNames('spotlight', {
        start: 189, end: 214, zeroPad: 0, prefix: 'spotlight0', suffix: '.png',
      }),
      frameRate: 20, repeat: 0,
    });

    this.endConfetti = this.add.sprite(config.width / 2, config.height / 2, 'endConfetti');
    this.anims.create({
      key: 'endConfetti',
      frames: this.anims.generateFrameNames('endConfetti', {
        start: 0, end: 120, zeroPad: 0, prefix: 'seq_0_', suffix: '.png',
      }),
      frameRate: 40, repeat: 0,
    });

    this.time.delayedCall(2000, () => {
      this.spotlight.play('spotlightOpen');
    });

    this.gameOver = this.add
      .sprite(config.width / 2, config.height / 2, 'gameOver')
      .setAlpha(0);
    this.tweens.add({
      targets: this.gameOver,
      ease: 'Expo.easeInOut',
      duration: 1000,
      delay: 300,
      alpha: { getStart: () => 0, getEnd: () => 1 },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.gameOver],
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      y: { getStart: () => config.height / 2, getEnd: () => config.height / 2 - 50 },
      yoyo: false,
      loop: 0,
    });

    this.nextButton = this.add
      .sprite(config.width / 2, 740, 'nextButton')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.iconDisplay = this.add
      .sprite(config.width / 2 - 80, config.height / 2 + 50, 'correctIcon')
      .setAlpha(0);

    if (gameState.gameWin == false) {
      this.gameOver.setTexture('gameOver');
      this.nextButton.setTexture('retryButton');
      this.iconDisplay.setTexture('incorrectIcon');
      this.retryText = this.add
        .text(
          config.width / 2 - 140,
          config.height / 2 + 200,
          `Solve atleast 6 problems correctly \n to clear the game`,
          { fontFamily: 'font1', fontSize: '18px', fill: '#ffffff' },
        )
        .setAlign('center')
        .setAlpha(0);
      this.tweens.add({
        targets: [this.retryText],
        ease: 'Linear',
        duration: 300,
        delay: 3000,
        alpha: { getStart: () => 0, getEnd: () => 1 },
        y: {
          getStart: () => config.height / 2 + 200,
          getEnd: () => config.height / 2 + 150,
        },
        yoyo: false,
        loop: 0,
      });
    } else {
      this.gameOver.setTexture('youWon');
      this.endConfetti.play('endConfetti');
      this.confettiaudio.play();
    }

    this.finalScore = this.add
      .text(
        config.width / 2 - 140,
        config.height / 2 + 140,
        `${gameState.correct}/${gameState.qnum} Problems`,
        { fontFamily: 'font1', fontSize: '18px', fill: '#ffffff' },
      )
      .setAlpha(0);

    this.hintsUsed = this.add
      .text(
        config.width / 2 + 30,
        config.height / 2 + 140,
        `${gameState.hints} Hints Used`,
        { fontFamily: 'font1', fontSize: '18px', fill: '#ffffff' },
      )
      .setAlpha(0);

    this.hintDisplay = this.add
      .sprite(config.width / 2 + 80, config.height / 2 + 100, 'hintIconMini')
      .setAlpha(0)
      .setScale(1);

    this.tweens.add({
      targets: [this.iconDisplay, this.hintDisplay],
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      y: {
        getStart: () => config.height / 2 + 100,
        getEnd: () => config.height / 2 + 50,
      },
      alpha: { getStart: () => 0, getEnd: () => 1 },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.finalScore, this.hintsUsed],
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      alpha: { getStart: () => 0, getEnd: () => 1 },
      y: {
        getStart: () => config.height / 2 + 140,
        getEnd: () => config.height / 2 + 100,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.nextButton],
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      alpha: { getStart: () => 0, getEnd: () => 1 },
      y: { getStart: () => 740, getEnd: () => 650 },
      yoyo: false,
      loop: 0,
    });

    this.okButton = this.add
      .sprite(config.width / 2, 720, 'okayButton')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.nextButton.on('pointerup', () => {
      if (gameState.gameWin == false) {
        gameState.attempted = 0;
        gameState.score = 0;
        gameState.hints = 0;
        gameState.gameWin = false;
        gameState.firstMistake = false;
        gameState.correct = 0;
        gameState.qnum = 0;
        gameState.questionNumber = 0;

        this.cameras.main.fadeOut(500, 255, 255, 255);

        this.cameras.main.once('camerafadeoutcomplete', () => {
          disablePointerEvents();
          this.scene.start('GameScene');
          this.scene.stop('EndScene');
        });
      } else {
        this.tweens.add({
          targets: [
            this.gameOver,
            this.iconDisplay,
            this.hintDisplay,
            this.finalScore,
            this.hintsUsed,
            this.nextButton,
          ],
          alpha: 0,
          duration: 300,
        });

        this.time.delayedCall(1000, () => {
          const midHeight = config.height / 2;
          const midWidth = config.width / 2;
          this.yOffset = 100;
          this.yOffsetOfCircle = 85;

          this.somev = 60;
          this.fromx = 603.7;
          this.fromy = 321.6 + this.somev - this.yOffset;
          this.tox = 610;
          this.toy = 368.8 + this.somev - this.yOffset;
          this.endx = 603.7;
          this.endy = 321.6 + this.somev - this.yOffset;

          this.centerxOfCircle = midWidth;
          this.centeryOfCircle = midHeight - this.yOffsetOfCircle;

          this.rewardAppearDelay = 1300;
          this.rewardMotionDuration = 1350;

          this.baseCircle = this.add
            .sprite(midWidth, midHeight, 'baseCircle')
            .setOrigin(0.5)
            .setVisible(true)
            .setScale(0.4);
          this.rewardLight = this.add
            .sprite(midWidth, midHeight, 'rewardLightAnim')
            .setOrigin(0.5)
            .setVisible(true)
            .setScale(0.4);

          this.compass = this.add
            .sprite(midWidth, midHeight + 170, 'compass')
            .setOrigin(0.5)
            .setVisible(false)
            .setAngle(0)
            .setScale(0);
          this.star = this.add
            .sprite(midWidth - 9, midHeight, 'star')
            .setOrigin(0.5)
            .setVisible(false)
            .setAngle(0)
            .setScale(0);
          this.glitter = this.add
            .sprite(midWidth + 30, midHeight - 65, 'glitter')
            .setOrigin(0.5)
            .setVisible(false)
            .setScale(0.8);

          this.endanim = true;

          this.graphics = this.add.graphics();
          this.path = { t: 0.6, vec: new Phaser.Math.Vector2() };

          this.curve = new Phaser.Curves.Ellipse(
            this.centerxOfCircle,
            this.centeryOfCircle,
            73,
            80,
          );

          this.tweens.add({
            targets: this.path,
            t: 0.7,
            ease: 'Sine.easeInOut',
            duration: 2700,
            yoyo: true,
            repeat: -1,
          });

          this.time.delayedCall(this.rewardAppearDelay, () => {
            this.compass.setVisible(true);
            this.star.setVisible(true);
          });

          this.tweens.add({
            targets: this.compass,
            x: midWidth,
            y: midHeight - this.yOffset,
            angle: 0,
            scale: 1,
            delay: this.rewardAppearDelay,
            ease: 'Linear',
            duration: 1000,
            yoyo: false,
            repeat: 0,
            completeDelay: 0,
            onStart: () => {
              this.rewardReveal.play();
            },
            onComplete: () => {
              this.tweens.add({
                targets: this.star,
                scale: { from: 0, to: 1 },
                ease: 'Sine.easeInOut',
                duration: this.rewardMotionDuration,
                yoyo: true,
                repeat: -1,
              });

              this.glitter.setVisible(true);
              this.glitter.play('showglitter');

              this.tweens.add({
                targets: this.curve.p0,
                y: this.centeryOfCircle + 70,
                ease: 'Sine.easeInOut',
                duration: this.rewardMotionDuration,
                yoyo: true,
                repeat: -1,
              });

              this.tweens.add({
                targets: this.compass,
                y: {
                  from: midHeight - this.yOffset,
                  to: midHeight + 70 - this.yOffset,
                },
                ease: 'Sine.easeInOut',
                duration: this.rewardMotionDuration,
                yoyo: true,
                repeat: -1,
              });
            },
          });

          this.baseCircle
            .play('circleopen')
            .once('animationcomplete', () => {
              this.baseCircle.play('circleglitterloop');
            });

          this.rewardLight.play('rewardopen');

          this.tweens.add({
            targets: this.okButton,
            ease: 'Linear',
            duration: 300,
            delay: 3000,
            alpha: 1,
            y: 650,
          });

          this.rewardEarned = this.add.sprite(577, 126, 'rewardEarned').setOrigin(0);
          this.rewardName = this.add.sprite(640, 560, 'rewardName').setOrigin(0.5, 0);
        });
      }
    });

    this.okButton.on('pointerup', () => {
      this.okButton.setTexture('disable_okayButton');
      this.okButton.removeInteractive();
    });

    this.nextButton.on('pointerover', () => {
      if (gameState.gameWin == false) {
        this.nextButton.setTexture('hover_retryButton');
      } else {
        this.nextButton.setTexture('hover_nextButton');
      }
    });
    this.nextButton.on('pointerout', () => {
      if (gameState.gameWin == false) {
        this.nextButton.setTexture('retryButton');
      } else {
        this.nextButton.setTexture('nextButton');
      }
    });

    this.okButton.on('pointerover', () => {
      this.okButton.setTexture('hover_okayButton');
    });
    this.okButton.on('pointerout', () => {
      this.okButton.setTexture('okayButton');
    });
  }

  update() {
    if (this.endanim) {
      this.graphics.clear();
      this.star.y = this.compass.y - 9;
      this.curve.getPoint(this.path.t, this.path.vec);
      this.glitter.setPosition(this.path.vec.x, this.path.vec.y);
    }
  }
}
